import { tokenSubTypes, tokenTypes } from '../Constants.js';
export default {
  type: 'ExpressionField.constantNumber',
  tokenize: (field, context) => {
    if (!field?.absoluteLocation) {
      return [];
    }
    return [{
      ...field.absoluteLocation,
      type: tokenTypes.CONSTANT,
      subType: tokenSubTypes.NUMBER
    }];
  }
};